import React from "react";

const PropertyDetails = ({
  title,
  image,
  price,
  location,
  description,
  features,
}) => {
  return (
    <div className="bg-white shadow-lg rounded-lg overflow-hidden">
      <img src={image} alt={title} className="w-full h-96 object-cover" />
      <div className="p-6">
        <h2 className="text-3xl font-semibold text-primary">{title}</h2>
        <p className="text-xl text-secondary mt-2">{location}</p>
        <p className="text-lg font-bold text-primary mt-4">${price}</p>
        <p className="text-md text-secondary mt-4">{description}</p>
        <ul className="mt-6">
          {features.map((feature, index) => (
            <li key={index} className="text-secondary">
              {feature}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default PropertyDetails;
